webpackJsonp([1],{

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3e4295c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Y+Qn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3e4295c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* jshint esversion: 6 */




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "OMfZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":"static/images/wahpro-wide-logo.png","alt":"WAH PRO Remote script Builder"}})]),_vm._v(" "),_c('nav',{staticClass:"navigation",attrs:{"role":"navigation"}},[_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://accessibility-helper.co.il/"}},[_vm._v("Home")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://accessibility-helper.co.il/about/"}},[_vm._v("About")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://accessibility-helper.co.il/contact/"}},[_vm._v("Contact")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://accessibility-helper.co.il/pro/"}},[_vm._v("WAH Pro")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y+Qn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('app-header'),_vm._v(" "),_c('div',{staticClass:"container"},[_c('builder')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YrQk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Builder_vue__ = __webpack_require__("ePL+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93d37716_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Builder_vue__ = __webpack_require__("tRk/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Builder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93d37716_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Builder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ePL+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'hello',
    data: function data() {
        return {
            uid: '',
            free_mode: false,
            code: '',
            copied: false,
            current_lang: 'en',
            current_live_lang: 'en',
            is_rtl: false,
            defaultLivePreviewBG: 'black',
            defaultLivePreviewColor: 'white',
            step3_scripts_jquery: '&lt;script src="https://code.jquery.com/jquery-1.12.4.min.js"&gt;',
            advancedStatus: false,
            advancedSettings: false, // custom translations
            locale: {
                en: {
                    mobile: 'Hide for mobile?',
                    lorem_ipsum: '<h1>Lorem title</h1><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>',
                    step1_title: 'Step 1 - Generate script code',
                    step2_title: 'Step 2 - Copy code',
                    step3_title: 'Step 3 - Insert code template into your page',
                    step3_script_config: '&lt;script&gt;&lt;!-- Paste your code from step 2 HERE --&gt;&lt;/script&gt;',
                    step3_description: '<p><strong>Paste the code just right before closing body tag &lt;/body&gt;.</p><p>jQuery library is required! So if you do not have it, please include it before calling WAH PRO script.</strong></p><p><strong>Please, double check your User ID, if User ID is not valid - WAH PRO remote script will NOT work.</strong></p><p>The example of result code:</p>',
                    title: 'Welcome to WAH PRO Remote script Builder',
                    subtitle: 'WP Accessibility Helper by WAH TEAM',
                    user_settings: 'User settings',
                    user_id: 'License key (required)',
                    theme_settings: 'Theme Settings',
                    theme_name: 'Theme color',
                    layout: 'Layout',
                    sidebar_position: 'Sidebar position',
                    setup_settings: 'Setup Settings',
                    language: 'Plugin Language',
                    enable_debug: 'Enable debug?',
                    enable_statistics: 'Enable statistics?',
                    show_icons_label: 'Show icons',
                    show_statement_label: 'Show Accessibility Statement',
                    disable_remove_animations: 'Disable "Remove animations" button?',
                    disable_highlight_titles: 'Disable "Highlight titles" button?',
                    disable_highlight_links: 'Disable "Highlight links" button?',
                    disable_keyboard_navigations: 'Disable "Keyboard navigation" button?',
                    disable_invert_colors: 'Disable "Invert colors" button?',
                    disable_readable_fonts: 'Disable "Readable fonts" button?',
                    english_label: 'English',
                    russian_label: 'Russian',
                    hebrew_label: 'Hebrew',
                    right_label: 'Right',
                    left_label: 'Left',
                    standart_label: 'Standart (1 columns)',
                    wide_label: 'Wide (2 columns)',
                    magic_label: 'Magic (animation effect)',
                    modern_label: 'Modern layout',
                    dark_label: 'Dark',
                    light_label: 'Light',
                    error_id_label: 'Important notice: User ID is required.',
                    notice_copied: 'Code has been copied!',
                    live_preview_title: 'Live preview',
                    jquery: 'I have <a href="https://jquery.com" target="_blank"><strong>jQuery</strong></a> installed on my website',
                    live: {
                        close: 'Close',
                        statement: 'Statement',
                        font_resize: 'Font Resize',
                        reset_font_size: 'Rest font size',
                        keyboard_navigation: 'Keyboard navigation',
                        readable_font: 'Readable font',
                        contrast: 'Contrast',
                        choose_color: 'Choose color',
                        highlight_links: 'Highlight links',
                        highlight_titles: 'Highlight titles',
                        clear_cookies: 'Reset',
                        images_greyscale: 'Images greyscale',
                        invert_colors: 'Invert colors',
                        remove_animations: 'Remove animations'
                    },
                    advanced_translation_settings: 'Advanced Translation Settings',
                    enable_label: 'Enable',
                    advanced_labels: {
                        close_button: 'Close button label',
                        font_resize: 'Font resize label',
                        font_size: 'Font sign (A+/A-) label',
                        reset_font_size: 'Reset font size label',
                        keyboard_navigation: 'Keyboard navigation label',
                        readable_font: 'Readable font label',
                        contrast: 'Contrast label',
                        choose_color: 'Choose color label',
                        highlight_links: 'Highlight links label',
                        highlight_titles: 'Highlight titles label',
                        clear_cookies: 'Clear cookies label',
                        images_greyscale: 'Images greyscale label',
                        invert_colors: 'Invert colors label',
                        remove_animations: 'Remove animations label'
                    }
                },
                ru: {
                    mobile: 'Спрятать на мобильных устройствах?',
                    lorem_ipsum: '<h1>Лорем ипсум заголовок</h1><p>Лорем ипсум долор сит амет, ут сит суас граецис трацтатос, ид дицта сонет модератиус сеа, ерос импедит хас ид. Реяуе тантас ментитум но про, еум ид воцент плацерат цонсеяуат. Нам ессе волутпат петентиум ут. Юсто нихил цонституам ан сед. Не цонвенире интерессет вел, дисцере алияуид феугаит при ид.</p>',
                    step1_title: 'Шаг 1 - Заполнить форму и получить код.',
                    step2_title: 'Шаг 2 - Скопировать код',
                    step3_title: 'Шаг 3 - Вставить код на вашу страничку',
                    step3_script_config: '&lt;script&gt;&lt;!-- Вставьте код полученный в шаге 2 сюда --&gt;&lt;/script&gt;',
                    step3_description: '<p>Вставить данный код перед закрытием тэга body</p><p>Библиотека jQuery должна быть добавлена на вашу страничку! В случае отсутсвия данной библиотеки скрипт работать не будет.</strong></p><p>Ваш скрипт должен выглядеть следующим образом:</p><p><strong>Пожалуйста, перепроверьте дважды ваш User ID, в противной случае скрипт работать не будет.</strong></p>',
                    title: 'Добро пожаловать в WAH PRO Remote script Builder',
                    subtitle: 'WP Accessibility Helper by WAH TEAM',
                    user_settings: 'Настройки пользователя',
                    user_id: 'ID пользователя (обязательно)',
                    theme_settings: 'Настройки шаблона',
                    theme_name: 'Цвет шаблона',
                    layout: 'Структура шаблона',
                    sidebar_position: 'Позиция',
                    setup_settings: 'Настройки',
                    language: 'Язык',
                    enable_debug: 'Включить debug?',
                    enable_statistics: 'Включить статистику?',
                    show_icons_label: 'Показать значки',
                    show_statement_label: 'Показать заявление о доступности',
                    disable_remove_animations: 'Отключить кнопку "Отключение анимации"?',
                    disable_highlight_titles: 'Отключить кнопку "Подсветка заголоков"?',
                    disable_highlight_links: 'Отключить кнопку "Подсветка ссылок"?',
                    disable_keyboard_navigations: 'Отключить кнопку "Навигации с клавиатуры"?',
                    disable_invert_colors: 'Отключить кнопку "Искажение цвета"?',
                    disable_readable_fonts: 'Отключить кнопку "Читаемый шрифт"?',
                    english_label: 'Английский (США и Великобритания)',
                    russian_label: 'Русский (Россия)',
                    hebrew_label: 'Иврит (Израиль)',
                    right_label: 'Справа',
                    left_label: 'Слева',
                    standart_label: 'Стандартный (1 колонка)',
                    wide_label: 'Широкий (2 колонки)',
                    magic_label: 'Волшебный (с эффектом анимации)',
                    dark_label: 'Тёмный',
                    light_label: 'Светлый',
                    error_id_label: 'Внимание! "User ID" это обязательный параметр. Без него ваш скрипт работать НЕ будет.',
                    notice_copied: 'Код скопирован в буфер обмена!',
                    live_preview_title: 'Предпросмотр',
                    jquery: '<a href="https://jquery.com" target="_blank"><strong>jQuery</strong></a> уже установлен на моем сайте',
                    live: {
                        close: 'Закрыть',
                        statement: 'заявление',
                        font_resize: 'Размер шрифта',
                        reset_font_size: 'Сбросить размер',
                        keyboard_navigation: 'Навигация с клавиатуры',
                        readable_font: 'Стандартный шрифт',
                        contrast: 'Контраст',
                        choose_color: 'Выбрать цвет',
                        highlight_links: 'Подсветить ссылки',
                        highlight_titles: 'Подсветить заголовки',
                        clear_cookies: 'Сбросить',
                        images_greyscale: 'Серый оттенок',
                        invert_colors: 'Инвертировать цвета',
                        remove_animations: 'Отключить анимацию'
                    },
                    advanced_translation_settings: 'Настройки перевода',
                    enable_label: 'Включить',
                    advanced_labels: {
                        close_button: 'Закрыть - метка',
                        font_resize: 'Размер фонта - метка',
                        font_size: 'Символ размера фонта (A+/A-) - метка',
                        reset_font_size: 'Сбросить размер фонта - метка',
                        keyboard_navigation: 'Навигация с клавиатуры - метка',
                        readable_font: 'Стандартный фонт - метка',
                        contrast: 'Контраст - метка',
                        choose_color: 'Выбрать цвет - метка',
                        highlight_links: 'Подсветить ссылки - метка',
                        highlight_titles: 'Подсветить заголовки - метка',
                        clear_cookies: 'Сбросить настройки - метка',
                        images_greyscale: 'Серые картинки - метка',
                        invert_colors: 'Инвертировать цвета - метка',
                        remove_animations: 'Отключить анимацию - метка'
                    }
                },
                he: {
                    mobile: 'הסתר לניידים?',
                    lorem_ipsum: '<h1>לורם איפסום כותרת</h1><p>לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית קוואזי במר מודוף. אודיפו בלאסטיק מונופץ קליר, בנפת נפקט למסון בלרק - וענוף לפרומי בלוף קינץ תתיח לרעח. לת צשחמי צש בליא, מנסוטו צמלח לביקו ננבי, צמוקו בלוקריה שיצמה ברורק.</p>',
                    step1_title: 'שלב 1 - למלא טופס ולקבל קוד התמאה.',
                    step2_title: 'שלב 2 - להעתיק קוד',
                    step3_title: 'שלב 3 - להדביר קוד לעמוד',
                    step3_script_config: '&lt;script&gt;&lt;!-- הדביקו קוד שקיבלתם בשלב 2 לכא --&gt;&lt;/script&gt;',
                    step3_description: '<p>תדביקו קוד שקבלתם ישר אחרי סגירה של תגית body.</p><p><strong>חייבים להוסיף ספריית jQuery לעמוד שלכם, אחרת הסקריפט לא יעבוד!</strong></p><p>קוד שלכם אמור להראות בצורה בהא:</p><p><strong>בבקשה, תבדקו פעמים את User ID שלכם, אחרת סקריפט לא יעבוד.</strong></p>',
                    title: 'ברוכים הבאים ל WAH PRO Remote script Builder',
                    subtitle: 'WP Accessibility Helper by WAH TEAM',
                    user_settings: 'הגדרות משתמש',
                    user_id: 'מזהה של משתמש (שדה חובה)',
                    theme_settings: 'הגדרות תבנית',
                    theme_name: 'צבע של תבנית',
                    layout: 'פריסת תבנית',
                    sidebar_position: 'מיקום של סרגל צד',
                    setup_settings: 'הדגרות',
                    language: 'שפה',
                    enable_debug: 'הפעל איתור שגיות?',
                    enable_statistics: 'הפעל סטטיסטיקה?',
                    show_icons_label: 'הצג אייקונים',
                    show_statement_label: 'הצג הצהרת נגישות',
                    disable_remove_animations: 'הסר כפתור "הסר אנימציות"?',
                    disable_highlight_titles: 'הסר כפתור "סימון כותרות"?',
                    disable_highlight_links: 'הסר כפתור "סימון קישורים"?',
                    disable_keyboard_navigations: 'הסר כפתור "ניווט מקלדת"?',
                    disable_invert_colors: 'הסר כפתור "היפוך צבעים"?',
                    disable_readable_fonts: 'הסר כפתור "פונט קריא"?',
                    english_label: 'אנגלית',
                    russian_label: 'רוסית',
                    hebrew_label: 'עברית',
                    right_label: 'צד ימין',
                    left_label: 'צד שמאל',
                    standart_label: 'רגיל (עמודה 1)',
                    wide_label: 'רחב (2 עמודות)',
                    magic_label: 'מגיק (אפקט אנימציה)',
                    dark_label: 'כהה',
                    light_label: 'בהיר',
                    error_id_label: 'שימו לב! מזהה של משתמש הוא שדה חובה. ללא מזהה תקין קוד לא יעבוד.',
                    notice_copied: 'קוד הועתק בהצלחה!',
                    live_preview_title: 'תצוגה מקדימה',
                    jquery: '<a href="https://jquery.com" target="_blank"><strong>jQuery</strong></a> כבר מותקן באתר',
                    live: {
                        close: 'סגור',
                        statement: 'הצהרה',
                        font_resize: 'גודל פונט',
                        reset_font_size: 'אפס גודל פונט',
                        keyboard_navigation: 'ניווט מקלדת',
                        readable_font: 'פונט קריא',
                        contrast: 'ניגודיות',
                        choose_color: 'בחר צבע',
                        highlight_links: 'סימון קישורים',
                        highlight_titles: 'סינון כותרות',
                        clear_cookies: 'איפוס',
                        images_greyscale: 'תמונות אפורות',
                        invert_colors: 'היפוך צבעים',
                        remove_animations: 'הסר אנימציה'
                    },
                    advanced_translation_settings: 'הגדרות תרגום',
                    enable_label: 'הפעל',
                    advanced_labels: {
                        close_button: 'סגור - תגית',
                        font_resize: 'גודל פונט - תגית',
                        font_size: 'סימן גודל פונט (A+/A-) - תגית',
                        reset_font_size: 'איפוס גודל פונט - תגית',
                        keyboard_navigation: 'ניווט מקלדת - תגית',
                        readable_font: 'פונט קריא - תגית',
                        contrast: 'ניגודיות - תגית',
                        choose_color: 'בחר צבע - תגית',
                        highlight_links: 'סימון קישורים - תגית',
                        highlight_titles: 'סימון כותרות - תגית',
                        clear_cookies: 'איפוס - תגית',
                        images_greyscale: 'תמונות אפורות - תגית',
                        invert_colors: 'היפוך צבעים - תגית',
                        remove_animations: 'הסר אנימציות - תגית'
                    }
                }
            },
            json: {
                theme: {
                    name: 'dark', // dark || light
                    position: 'right', // right || left
                    type: 4 // 1 = standart, 2 = wide, 3 = magic, 4 = modern
                },
                setup: {
                    debug: true, // true or false
                    stats: true, // true or false
                    lang: 'en', // en, ru, he [default en]
                    jquery: false, // true or false,
                    mobile: true,
                    show_icons: false,
                    show_statement: false,
                    hide: {
                        remove_animations: false,
                        highlight_titles: false,
                        highlight_links: false,
                        keyboard_navigation: false,
                        invert_colors: false,
                        readable_fonts: false,
                        contrast: false
                    }
                }
            },
            advanced: {
                close: 'Close',
                font_resize: 'Font Resize',
                font_resize_sign: 'A',
                reset_font_size: 'Rest font size',
                keyboard_navigation: 'Keyboard navigation',
                readable_font: 'Readable font',
                contrast: 'Contrast',
                choose_color: 'Choose color',
                highlight_links: 'Highlight links',
                highlight_titles: 'Highlight titles',
                clear_cookies: 'Clear cookies',
                images_greyscale: 'Images greyscale',
                invert_colors: 'Invert colors',
                remove_animations: 'Remove animations'
            }
        };
    },

    methods: {
        updateAdvancedSettings: function updateAdvancedSettings() {

            this.advancedStatus = !this.advancedStatus;

            if (this.advancedSettings) {
                this.json.setup.translations = this.advanced;
            } else {
                delete this.json.setup.translations;
            }

            this.generateCode();
        },
        generateCode: function generateCode() {
            var str_start = 'var wahproConfig = ';
            var str = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.json, undefined, 4);
            var str_end = ';';
            var str_result = str_start + str + str_end;
            this.code = str_result;
        },
        selectCode: function selectCode() {
            var textarea = this.$refs.codeEditor;
            textarea.select();
            document.execCommand("copy");
            this.copied = true;
            setTimeout(function () {
                this.copied = false;
            }.bind(this), 3000);
        },
        updateLocale: function updateLocale(lang) {
            this.is_rtl = lang == 'he' ? true : false;
            this.current_lang = lang;
        },
        updateLivePreviewLanguage: function updateLivePreviewLanguage(lang) {
            this.current_live_lang = this.json.setup.lang;
        },
        switchLivePreviewBG: function switchLivePreviewBG(bg, color) {
            this.defaultLivePreviewBG = bg;
            this.defaultLivePreviewColor = color;
        }
    },
    watch: {
        json: {
            handler: function handler(val, oldVal) {
                this.generateCode();
            },
            deep: true
        },
        advanced: {
            handler: function handler(val, oldVal) {
                this.generateCode();
            },
            deep: true
        }
    },
    mounted: function mounted() {
        this.generateCode();
    }
});

/***/ }),

/***/ "tRk/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"builder",class:{rtl : _vm.is_rtl}},[_c('div',{staticClass:"locale-selector"},[_c('button',{staticClass:"lang-en",class:{'activeLang' : this.current_lang == 'en'},attrs:{"type":"button"},on:{"click":function($event){return _vm.updateLocale('en')}}},[_c('img',{attrs:{"src":"static/images/us.svg","alt":"English"}})]),_vm._v(" "),_c('button',{staticClass:"lang-ru",class:{'activeLang' : this.current_lang == 'ru'},attrs:{"type":"button"},on:{"click":function($event){return _vm.updateLocale('ru')}}},[_c('img',{attrs:{"src":"static/images/ru.svg","alt":"Russian"}})]),_vm._v(" "),_c('button',{staticClass:"lang-he",class:{'activeLang' : this.current_lang == 'he'},attrs:{"type":"button"},on:{"click":function($event){return _vm.updateLocale('he')}}},[_c('img',{attrs:{"src":"static/images/il.svg","alt":"Hebrew"}})])]),_vm._v(" "),_c('div',{staticClass:"page-titles"},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.locale[_vm.current_lang].title))]),_vm._v(" "),_c('h2',{staticClass:"page-sub-title"},[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].subtitle))])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"step-header"},[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].step1_title))])]),_vm._v(" "),_c('div',{staticClass:"builder-form-wrapper"},[_c('form',{staticClass:"builder-form",attrs:{"method":"post"},on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"form-row is-user-id-row"},[_c('h3',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].user_settings)+":")])]),_vm._v(" "),(!_vm.free_mode)?_c('div',[_c('label',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].user_id)+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.uid),expression:"uid"}],attrs:{"type":"text"},domProps:{"value":(_vm.uid)},on:{"input":function($event){if($event.target.composing){ return; }_vm.uid=$event.target.value}}})])]):_vm._e()]),_vm._v(" "),(!_vm.free_mode)?_c('div',{staticClass:"form-row is-theme_settings-row"},[_c('h3',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].theme_settings)+":")])]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].theme_name)+":")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.json.theme.name),expression:"json.theme.name"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.json.theme, "name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"dark"}},[_vm._v(_vm._s(_vm.locale[_vm.current_lang].dark_label))]),_vm._v(" "),_c('option',{attrs:{"value":"light"}},[_vm._v(_vm._s(_vm.locale[_vm.current_lang].light_label))])])]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].layout)+":")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.json.theme.type),expression:"json.theme.type"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.json.theme, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v(_vm._s(_vm.locale[_vm.current_lang].standart_label))]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v(_vm._s(_vm.locale[_vm.current_lang].wide_label))]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v(_vm._s(_vm.locale[_vm.current_lang].magic_label))]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v(_vm._s(_vm.locale[_vm.current_lang].modern_label))])])]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].sidebar_position)+":")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.json.theme.position),expression:"json.theme.position"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.json.theme, "position", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"right"}},[_vm._v(_vm._s(_vm.locale[_vm.current_lang].right_label))]),_vm._v(" "),_c('option',{attrs:{"value":"left"}},[_vm._v(_vm._s(_vm.locale[_vm.current_lang].left_label))])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-row is-setup_settings-row"},[_c('h3',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].setup_settings)+":")])]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].language)+":")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.json.setup.lang),expression:"json.setup.lang"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.json.setup, "lang", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){return _vm.updateLivePreviewLanguage()}]}},[_c('option',{attrs:{"value":"en"}},[_vm._v(_vm._s(_vm.locale[_vm.current_lang].english_label))]),_vm._v(" "),_c('option',{attrs:{"value":"ru"}},[_vm._v(_vm._s(_vm.locale[_vm.current_lang].russian_label))]),_vm._v(" "),_c('option',{attrs:{"value":"he"}},[_vm._v(_vm._s(_vm.locale[_vm.current_lang].hebrew_label))])])]),_vm._v(" "),_c('div',{staticClass:"setup_inputs_wrapper"},[(_vm.json.theme.type==4)?_c('label',{staticClass:"inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.json.setup.show_icons),expression:"json.setup.show_icons"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.json.setup.show_icons)?_vm._i(_vm.json.setup.show_icons,null)>-1:(_vm.json.setup.show_icons)},on:{"change":function($event){var $$a=_vm.json.setup.show_icons,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.json.setup, "show_icons", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.json.setup, "show_icons", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.json.setup, "show_icons", $$c)}}}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.locale[_vm.current_lang].show_icons_label)}})]):_vm._e(),_vm._v(" "),(_vm.json.theme.type==4)?_c('label',{staticClass:"inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.json.setup.show_statement),expression:"json.setup.show_statement"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.json.setup.show_statement)?_vm._i(_vm.json.setup.show_statement,null)>-1:(_vm.json.setup.show_statement)},on:{"change":function($event){var $$a=_vm.json.setup.show_statement,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.json.setup, "show_statement", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.json.setup, "show_statement", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.json.setup, "show_statement", $$c)}}}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.locale[_vm.current_lang].show_statement_label)}})]):_vm._e(),_vm._v(" "),_c('label',{staticClass:"inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.json.setup.jquery),expression:"json.setup.jquery"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.json.setup.jquery)?_vm._i(_vm.json.setup.jquery,null)>-1:(_vm.json.setup.jquery)},on:{"change":function($event){var $$a=_vm.json.setup.jquery,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.json.setup, "jquery", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.json.setup, "jquery", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.json.setup, "jquery", $$c)}}}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.locale[_vm.current_lang].jquery)}})]),_vm._v(" "),(!_vm.free_mode)?_c('div',[(_vm.json.theme.type!=4)?_c('label',{staticClass:"inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.json.setup.debug),expression:"json.setup.debug"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.json.setup.debug)?_vm._i(_vm.json.setup.debug,null)>-1:(_vm.json.setup.debug)},on:{"change":function($event){var $$a=_vm.json.setup.debug,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.json.setup, "debug", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.json.setup, "debug", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.json.setup, "debug", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].enable_debug))])]):_vm._e(),_vm._v(" "),(_vm.json.theme.type!=4)?_c('label',{staticClass:"inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.json.setup.stats),expression:"json.setup.stats"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.json.setup.stats)?_vm._i(_vm.json.setup.stats,null)>-1:(_vm.json.setup.stats)},on:{"change":function($event){var $$a=_vm.json.setup.stats,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.json.setup, "stats", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.json.setup, "stats", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.json.setup, "stats", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].enable_statistics))])]):_vm._e(),_vm._v(" "),(_vm.json.theme.type!=4)?_c('label',{staticClass:"inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.json.setup.hide.remove_animations),expression:"json.setup.hide.remove_animations"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.json.setup.hide.remove_animations)?_vm._i(_vm.json.setup.hide.remove_animations,null)>-1:(_vm.json.setup.hide.remove_animations)},on:{"change":function($event){var $$a=_vm.json.setup.hide.remove_animations,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.json.setup.hide, "remove_animations", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.json.setup.hide, "remove_animations", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.json.setup.hide, "remove_animations", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].disable_remove_animations))])]):_vm._e(),_vm._v(" "),(_vm.json.theme.type!=4)?_c('label',{staticClass:"inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.json.setup.hide.highlight_titles),expression:"json.setup.hide.highlight_titles"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.json.setup.hide.highlight_titles)?_vm._i(_vm.json.setup.hide.highlight_titles,null)>-1:(_vm.json.setup.hide.highlight_titles)},on:{"change":function($event){var $$a=_vm.json.setup.hide.highlight_titles,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.json.setup.hide, "highlight_titles", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.json.setup.hide, "highlight_titles", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.json.setup.hide, "highlight_titles", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].disable_highlight_titles))])]):_vm._e(),_vm._v(" "),(_vm.json.theme.type!=4)?_c('label',{staticClass:"inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.json.setup.hide.highlight_links),expression:"json.setup.hide.highlight_links"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.json.setup.hide.highlight_links)?_vm._i(_vm.json.setup.hide.highlight_links,null)>-1:(_vm.json.setup.hide.highlight_links)},on:{"change":function($event){var $$a=_vm.json.setup.hide.highlight_links,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.json.setup.hide, "highlight_links", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.json.setup.hide, "highlight_links", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.json.setup.hide, "highlight_links", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].disable_highlight_links))])]):_vm._e(),_vm._v(" "),(_vm.json.theme.type!=4)?_c('label',{staticClass:"inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.json.setup.hide.keyboard_navigation),expression:"json.setup.hide.keyboard_navigation"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.json.setup.hide.keyboard_navigation)?_vm._i(_vm.json.setup.hide.keyboard_navigation,null)>-1:(_vm.json.setup.hide.keyboard_navigation)},on:{"change":function($event){var $$a=_vm.json.setup.hide.keyboard_navigation,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.json.setup.hide, "keyboard_navigation", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.json.setup.hide, "keyboard_navigation", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.json.setup.hide, "keyboard_navigation", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].disable_keyboard_navigations))])]):_vm._e(),_vm._v(" "),(_vm.json.theme.type!=4)?_c('label',{staticClass:"inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.json.setup.hide.invert_colors),expression:"json.setup.hide.invert_colors"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.json.setup.hide.invert_colors)?_vm._i(_vm.json.setup.hide.invert_colors,null)>-1:(_vm.json.setup.hide.invert_colors)},on:{"change":function($event){var $$a=_vm.json.setup.hide.invert_colors,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.json.setup.hide, "invert_colors", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.json.setup.hide, "invert_colors", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.json.setup.hide, "invert_colors", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].disable_invert_colors))])]):_vm._e(),_vm._v(" "),(_vm.json.theme.type!=4)?_c('label',{staticClass:"inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.json.setup.hide.readable_fonts),expression:"json.setup.hide.readable_fonts"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.json.setup.hide.readable_fonts)?_vm._i(_vm.json.setup.hide.readable_fonts,null)>-1:(_vm.json.setup.hide.readable_fonts)},on:{"change":function($event){var $$a=_vm.json.setup.hide.readable_fonts,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.json.setup.hide, "readable_fonts", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.json.setup.hide, "readable_fonts", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.json.setup.hide, "readable_fonts", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].disable_readable_fonts))])]):_vm._e()]):_vm._e()])])]),_vm._v(" "),(_vm.code)?_c('div',{staticClass:"builder-live"},[_c('h3',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].live_preview_title)+":")])]),_vm._v(" "),_c('div',{staticClass:"live-preview-bg-colors"},[_c('button',{staticClass:"bg-button black",on:{"click":function($event){return _vm.switchLivePreviewBG('#000', '#FFF')}}}),_vm._v(" "),_c('button',{staticClass:"bg-button white",on:{"click":function($event){return _vm.switchLivePreviewBG('#FFF', '#000')}}}),_vm._v(" "),_c('button',{staticClass:"bg-button grey",on:{"click":function($event){return _vm.switchLivePreviewBG('#ddd', '#000')}}}),_vm._v(" "),_c('button',{staticClass:"bg-button blue",on:{"click":function($event){return _vm.switchLivePreviewBG('blue', '#FFF')}}})]),_vm._v(" "),_c('div',{staticClass:"builder-live-content",style:({
                        'background' : _vm.defaultLivePreviewBG,
                        'color' : _vm.defaultLivePreviewColor
                    })},[_c('div',{staticClass:"builder-lorem",domProps:{"innerHTML":_vm._s(_vm.locale[_vm.current_lang].lorem_ipsum)}}),_vm._v(" "),(this.json.theme.type != 4)?_c('div',{staticClass:"accessability_container active",class:{
                            'dark_theme' : _vm.json.theme.name == 'dark',
                            'light_theme' : _vm.json.theme.name == 'light',
                            'accessibility-location-right' : _vm.json.theme.position == 'right',
                            'accessibility-location-left' : _vm.json.theme.position == 'left',
                            'wahpro-wide-sidebar' : _vm.json.theme.type == 2,
                            'wahpro-magic-sidebar' : _vm.json.theme.type == 3,
							'wahpro-wah-modern' : _vm.json.theme.type == 4,
                            'is-rtl' : _vm.json.setup.lang == 'he'
                            },attrs:{"id":"wp_access_helper_container"}},[_c('div',{attrs:{"id":"access_container","aria-hidden":"false"}},[_c('button',{staticClass:"close_container wahout",attrs:{"type":"button"}},[_vm._v("\n                                "+_vm._s(_vm.advancedSettings ? _vm.advanced.close : _vm.locale[_vm.current_live_lang].live.close)+"\n                            ")]),_vm._v(" "),_c('div',{staticClass:"access_container_inner"},[_c('div',{staticClass:"a_module wah_font_resize"},[_c('div',{staticClass:"a_module_title"},[_vm._v("\n                                        "+_vm._s(_vm.advancedSettings ? _vm.advanced.font_resize : _vm.locale[_vm.current_live_lang].live.font_resize)+"\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"a_module_exe font_resizer"},[_c('button',{staticClass:"wah-action-button smaller wahout",attrs:{"type":"button"}},[_vm._v("\n                                            "+_vm._s(_vm.advancedSettings ? _vm.advanced.font_resize_sign : 'A')+"-\n                                        ")]),_vm._v(" "),_c('button',{staticClass:"wah-action-button larger wahout",attrs:{"type":"button"}},[_vm._v("\n                                            "+_vm._s(_vm.advancedSettings ? _vm.advanced.font_resize_sign : 'A')+"+\n                                        ")]),_vm._v(" "),_c('button',{staticClass:"wah-action-button wah-font-reset wahout",attrs:{"type":"button"}},[_vm._v("\n                                            "+_vm._s(_vm.advancedSettings ? _vm.advanced.reset_font_size : _vm.locale[_vm.current_live_lang].live.reset_font_size)+"\n                                        ")])])]),_vm._v(" "),(!_vm.json.setup.hide.keyboard_navigation)?_c('div',{staticClass:"a_module wah_keyboard_navigation"},[_c('div',{staticClass:"a_module_exe"},[_c('button',{staticClass:"wah-action-button wahout wah-call-keyboard-navigation",attrs:{"type":"button"}},[_vm._v("\n                                            "+_vm._s(_vm.advancedSettings ? _vm.advanced.keyboard_navigation : _vm.locale[_vm.current_live_lang].live.keyboard_navigation)+"\n                                        ")])])]):_vm._e(),_vm._v(" "),(!_vm.json.setup.hide.readable_fonts)?_c('div',{staticClass:"a_module wah_readable_fonts"},[_c('div',{staticClass:"a_module_exe readable_fonts"},[_c('button',{staticClass:"wah-action-button wahout wah-call-readable-fonts",attrs:{"type":"button"}},[_vm._v("\n                                            "+_vm._s(_vm.advancedSettings ? _vm.advanced.readable_font :_vm.locale[_vm.current_live_lang].live.readable_font)+"\n                                        ")])])]):_vm._e(),_vm._v(" "),(!_vm.json.setup.hide.contrast)?_c('div',{staticClass:"a_module wah_contrast_trigger"},[_c('div',{staticClass:"a_module_title"},[_vm._v(_vm._s(_vm.locale[_vm.current_live_lang].live.contrast))]),_vm._v(" "),_c('div',{staticClass:"a_module_exe"},[_c('button',{staticClass:"contrast_trigger wah-action-button wahout wah-call-contrast-trigger",attrs:{"type":"button","id":"contrast_trigger"}},[_vm._v("\n                                            "+_vm._s(_vm.advancedSettings ? _vm.advanced.choose_color : _vm.locale[_vm.current_live_lang].live.choose_color)+"\n                                        ")])])]):_vm._e(),_vm._v(" "),(!_vm.json.setup.hide.highlight_links)?_c('div',{staticClass:"a_module wah_highlight_links"},[_c('div',{staticClass:"a_module_exe"},[_c('button',{staticClass:"wah-action-button wahout wah-call-highlight-links",attrs:{"type":"button"}},[_vm._v("\n                                            "+_vm._s(_vm.advancedSettings ? _vm.advanced.highlight_links : _vm.locale[_vm.current_live_lang].live.highlight_links)+"\n                                        ")])])]):_vm._e(),_vm._v(" "),(!_vm.json.setup.hide.highlight_titles)?_c('div',{staticClass:"a_module wah_highlight_titles"},[_c('div',{staticClass:"a_module_exe"},[_c('button',{staticClass:"wah-action-button wahout wah-call-highlight-titles",attrs:{"type":"button"}},[_vm._v("\n                                            "+_vm._s(_vm.advancedSettings ? _vm.advanced.highlight_titles : _vm.locale[_vm.current_live_lang].live.highlight_titles)+"\n                                        ")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"a_module wah_clear_cookies"},[_c('div',{staticClass:"a_module_exe"},[_c('button',{staticClass:"wah-action-button wahout wah-call-clear-cookies",attrs:{"type":"button"}},[_vm._v("\n                                            "+_vm._s(_vm.advancedSettings ? _vm.advanced.clear_cookies : _vm.locale[_vm.current_live_lang].live.clear_cookies)+"\n                                        ")])])]),_vm._v(" "),_c('div',{staticClass:"a_module wah_greyscale"},[_c('div',{staticClass:"a_module_exe"},[_c('button',{staticClass:"greyscale wah-action-button wahout wah-call-greyscale",attrs:{"type":"button","id":"greyscale"}},[_vm._v("\n                                            "+_vm._s(_vm.advancedSettings ? _vm.advanced.images_greyscale : _vm.locale[_vm.current_live_lang].live.images_greyscale)+"\n                                        ")])])]),_vm._v(" "),(!_vm.json.setup.hide.invert_colors)?_c('div',{staticClass:"a_module wah_invert"},[_c('div',{staticClass:"a_module_exe"},[_c('button',{staticClass:"wah-action-button wahout wah-call-invert",attrs:{"type":"button"}},[_vm._v("\n                                            "+_vm._s(_vm.advancedSettings ? _vm.advanced.invert_colors : _vm.locale[_vm.current_live_lang].live.invert_colors)+"\n                                        ")])])]):_vm._e(),_vm._v(" "),(!_vm.json.setup.hide.remove_animations)?_c('div',{staticClass:"a_module wah_remove_animations"},[_c('div',{staticClass:"a_module_exe"},[_c('button',{staticClass:"wah-action-button wahout wah-call-remove-animations",attrs:{"type":"button","accesskey":"a"}},[_vm._v("\n                                            "+_vm._s(_vm.advancedSettings ? _vm.advanced.remove_animations : _vm.locale[_vm.current_live_lang].live.remove_animations)+"\n                                        ")])])]):_vm._e()])])]):_vm._e(),_vm._v(" "),(this.json.theme.type == 4)?_c('aside',{staticClass:"accessability_container active",class:{
                            'dark_theme' : _vm.json.theme.name == 'dark',
                            'light_theme' : _vm.json.theme.name == 'light',
                            'accessibility-location-right' : _vm.json.theme.position == 'right',
                            'accessibility-location-left' : _vm.json.theme.position == 'left',
                            'wahpro-wide-sidebar' : _vm.json.theme.type == 2,
                            'wahpro-magic-sidebar' : _vm.json.theme.type == 3,
							'wahpro-wah-modern' : _vm.json.theme.type == 4,
                            'is-rtl' : _vm.json.setup.lang == 'he'
                            },attrs:{"id":"wp_access_helper_container"}},[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"access_container","aria-hidden":"false"}},[_c('div',{staticClass:"wahpro-buttons-header"},[_c('button',{staticClass:"close_container wahout",attrs:{"tabindex":"0","type":"button","accesskey":"x","aria-label":"Close","title":"Close"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.locale[_vm.current_lang].live.close)}})]),_vm._v(" "),_c('button',{staticClass:"wah-action-button wahout wah-call-clear-cookies",class:{
										'show_statement-off' : _vm.json.setup.show_statement==false
									},attrs:{"data-widgetid":"widget-7","type":"button","aria-label":"Reset Settings","title":"Reset Settings","tabindex":"0"}},[(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-icon goi-beveled-rows",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.locale[_vm.current_lang].live.clear_cookies)}})]),_vm._v(" "),(_vm.json.setup.show_statement==true)?_c('button',{staticClass:"wahout",attrs:{"type":"button","id":"wahpro-accessibility-statement","aria-label":"Statement","aria-haspopup":"true","aria-expanded":"false","tabindex":"0"}},[(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-info-b",attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.locale[_vm.current_lang].live.statement)}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"access_container_inner",staticStyle:{"overflow":"hidden","outline":"none"},attrs:{"tabindex":"1"}},[_c('div',{staticClass:"wahpro-font-settings-wrapper"},[_c('div',{staticClass:"a_module wah_readable_fonts"},[_c('div',{staticClass:"a_module_exe readable_fonts"},[_c('button',{staticClass:"wah-action-button wahout wah-call-readable-fonts",attrs:{"tabindex":"0","data-widgetid":"widget-3","type":"button","aria-label":"Readable Font","title":"Readable Font"}},[(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-icon goi-letter-inside-black"}):_vm._e(),_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tReadable Font\n\t\t\t\t\t\t\t\t\t\t\t")])])]),_vm._v(" "),_c('div',{staticClass:"font-size-settings-inner"},[_c('div',{staticClass:"a_module wah_font_resize separate_small_font_size"},[_c('div',{staticClass:"a_module_exe font_resizer"},[_c('button',{staticClass:"wah-action-button smaller wahout",attrs:{"tabindex":"0","type":"button","title":"smaller font size","aria-label":"smaller font size"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tA-"),(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-icon goi-letter-a"}):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"a_module wah_font_resize separate_large_font_size"},[_c('div',{staticClass:"a_module_exe font_resizer"},[_c('button',{staticClass:"wah-action-button larger wahout",attrs:{"tabindex":"0","type":"button","title":"larger font size","aria-label":"larger font size"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tA+"),(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-icon goi-letter-a"}):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"a_module wah_font_resize separate_reset_font_size"},[_c('button',{staticClass:"wah-action-button wah-font-reset wahout",attrs:{"tabindex":"0","type":"button","title":"Reset font size","aria-label":"Reset font size"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tReset font size"),(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-icon goi-refresh"}):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"font-alignment-settings-inner"},[_c('div',{staticClass:"a_module"},[_c('div',{staticClass:"a_module_exe"},[_c('label',{staticClass:"wah-action-button wah-uniqid wahout set-wah_text_alignment_left",attrs:{"tabindex":"0","data-widgetid":"widget-23","type":"button","id":"wah_text_alignment_left","aria-label":"Align left","data-wahaction":"align-left"}},[_c('input',{attrs:{"type":"checkbox","name":"wah_text_alignment_left"}}),_vm._v(" "),_c('span',{staticClass:"wahpro-checkbox-indicator"}),_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tAlign left"),(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-icon goi-align-left"}):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"a_module"},[_c('div',{staticClass:"a_module_exe"},[_c('label',{staticClass:"wah-action-button wah-uniqid wahout set-wah_text_alignment_center",attrs:{"tabindex":"0","data-widgetid":"widget-23","type":"button","id":"wah_text_alignment_center","aria-label":"Align center","data-wahaction":"align-center"}},[_c('input',{attrs:{"type":"checkbox","name":"wah_text_alignment_center"}}),_vm._v(" "),_c('span',{staticClass:"wahpro-checkbox-indicator"}),_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tAlign center\n\t\t\t\t\t\t\t\t\t\t\t\t\t"),(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-icon goi-align-center-hor"}):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"a_module"},[_c('div',{staticClass:"a_module_exe"},[_c('label',{staticClass:"wah-action-button wah-uniqid wahout set-wah_text_alignment_right",attrs:{"tabindex":"0","data-widgetid":"widget-23","type":"button","id":"wah_text_alignment_right","aria-label":"Align right","data-wahaction":"align-right"}},[_c('input',{attrs:{"type":"checkbox","name":"wah_text_alignment_right"}}),_vm._v(" "),_c('span',{staticClass:"wahpro-checkbox-indicator"}),_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\tAlign right"),(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-icon goi-align-right"}):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"wahpro-modern-contrast-settings"},[_c('div',{staticClass:"a_module wah_contrast_trigger"},[_c('div',{staticClass:"a_module_exe contrast_module_exe"},[_c('label',{staticClass:"contrast_trigger wah-action-button wahout wah-call-contrast-trigger",attrs:{"tabindex":"0","data-widgetid":"widget-4","id":"contrast_trigger","title":"Adjust Background Colors"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tAdjust Background Colors"),(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-icon goi-pipette"}):_vm._e()]),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"wahpro-modern-title-colors-settings"},[_c('div',{staticClass:"a_module wah_titles_colors_trigger"},[_c('div',{staticClass:"a_module_exe titles_colors_module_exe"},[_c('label',{staticClass:"wahout wah-call-titles_colors",attrs:{"tabindex":"-1","data-widgetid":"widget-4","type":"button","id":"titles_colors_trigger","title":"Contrast"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tAdjust Title Colors title"),(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-icon goi-color"}):_vm._e()]),_vm._v(" "),_vm._m(2)])])]),_vm._v(" "),_c('div',{staticClass:"wahpro-modern-text-colors-settings"},[_c('div',{staticClass:"a_module wah_text_colors_trigger"},[_c('div',{staticClass:"a_module_exe text_colors_module_exe"},[_c('label',{staticClass:"wahout wah-call-text_colors",attrs:{"tabindex":"-1","data-widgetid":"widget-text-colors","type":"button","id":"titles_colors_trigger","aria-label":"Adjust Text Colors title"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tAdjust Text Colors title"),(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-icon goi-color"}):_vm._e()]),_vm._v(" "),_vm._m(3)])])]),_vm._v(" "),_c('div',{staticClass:"wahpro-modern-link-colors-settings"},[_c('div',{staticClass:"a_module wah_link_colors_trigger"},[_c('div',{staticClass:"a_module_exe link_colors_module_exe"},[_c('label',{staticClass:"wahout wah-call-link_colors",attrs:{"tabindex":"-1","data-widgetid":"widget-text-colors","type":"button","id":"links_colors_trigger"}},[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\tAdjust Link Colors"),(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-icon goi-color"}):_vm._e()]),_vm._v(" "),_vm._m(4)])])]),_vm._v(" "),_c('div',{staticClass:"wahpro-switches-wrapper"},[_c('div',{staticClass:"a_module wah_keyboard_navigation",attrs:{"data-module":"widget-2"}},[_c('div',{staticClass:"a_module_exe"},[_c('ol',{staticClass:"switches",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}},[_c('li',{staticClass:"wahout"},[_c('input',{attrs:{"type":"checkbox","tabindex":"-1","id":"widget-2","name":"widget-2"}}),_vm._v(" "),_c('label',{staticClass:"wah-action-button wahout wah-call-keyboard-navigation is-wah-label",attrs:{"for":"widget-2","data-widgetid":"widget-2","tabindex":"0"}},[_c('span',{staticClass:"wah-module-title"},[(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-keyboard"}):_vm._e(),_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tKeyboard navigation"),_c('div',{staticClass:"wah-module-desciption"},[_vm._v("Keyboard navigation assistant")])]),_vm._v(" "),_c('span',{staticClass:"wah-animate-checkbox",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"a_module wah_underline_links",attrs:{"data-module":"widget-5"}},[_c('div',{staticClass:"a_module_exe"},[_c('ol',{staticClass:"switches",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}},[_c('li',{staticClass:"wahout"},[_c('input',{attrs:{"type":"checkbox","tabindex":"-1","id":"widget-5","name":"widget-5"}}),_vm._v(" "),_c('label',{staticClass:"wah-action-button wahout wah-call-underline-links is-wah-label",attrs:{"for":"widget-5","data-widgetid":"widget-5","tabindex":"0"}},[_c('span',{staticClass:"wah-module-title",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}},[(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-underline"}):_vm._e(),_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tUnderline links"),_c('div',{staticClass:"wah-module-desciption"},[_vm._v("Underline all links on this page")])]),_vm._v(" "),_c('span',{staticClass:"wah-animate-checkbox",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"a_module wah_highlight_links",attrs:{"data-module":"widget-6"}},[_c('div',{staticClass:"a_module_exe"},[_c('ol',{staticClass:"switches",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}},[_c('li',{staticClass:"wahout"},[_c('input',{attrs:{"type":"checkbox","tabindex":"-1","id":"widget-6","name":"widget-6"}}),_vm._v(" "),_c('label',{staticClass:"wah-action-button wahout wah-call-highlight-links is-wah-label",attrs:{"for":"widget-6","data-widgetid":"widget-6","tabindex":"0"}},[_c('span',{staticClass:"wah-module-title",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}},[(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-luminous-bulb"}):_vm._e(),_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tHighlight Links"),_c('div',{staticClass:"wah-module-desciption"},[_vm._v("Highlight all links on this page")])]),_vm._v(" "),_c('span',{staticClass:"wah-animate-checkbox",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"a_module wah_greyscale",attrs:{"data-module":"widget-8"}},[_c('div',{staticClass:"a_module_exe"},[_c('ol',{staticClass:"switches",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}},[_c('li',{staticClass:"wahout"},[_c('input',{attrs:{"type":"checkbox","tabindex":"-1","id":"widget-8","name":"widget-8"}}),_vm._v(" "),_c('label',{staticClass:"greyscale wah-action-button wahout wah-call-greyscale is-wah-label",attrs:{"for":"widget-8","data-widgetid":"widget-8","tabindex":"0"}},[_c('span',{staticClass:"wah-module-title",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}},[(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-crossed-out-drop"}):_vm._e(),_vm._v("Images Greyscale"),_c('div',{staticClass:"wah-module-desciption"},[_vm._v("Greyscale images on this page")])]),_vm._v(" "),_c('span',{staticClass:"wah-animate-checkbox",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"a_module wah_invert",attrs:{"data-module":"widget-9"}},[_c('div',{staticClass:"a_module_exe"},[_c('ol',{staticClass:"switches",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}},[_c('li',{staticClass:"wahout"},[_c('input',{attrs:{"type":"checkbox","tabindex":"-1","id":"widget-9","name":"widget-9"}}),_vm._v(" "),_c('label',{staticClass:"wah-action-button wahout wah-call-invert is-wah-label",attrs:{"for":"widget-9","data-widgetid":"widget-9","tabindex":"0"}},[_c('span',{staticClass:"wah-module-title",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}},[(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-half-a-drop"}):_vm._e(),_vm._v("Invert Colors"),_c('div',{staticClass:"wah-module-desciption"},[_vm._v("Invert colors on this page")])]),_vm._v(" "),_c('span',{staticClass:"wah-animate-checkbox",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"a_module wah_remove_animations",attrs:{"data-module":"widget-10"}},[_c('div',{staticClass:"a_module_exe"},[_c('ol',{staticClass:"switches",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}},[_c('li',{staticClass:"wahout"},[_c('input',{attrs:{"type":"checkbox","tabindex":"-1","id":"widget-10","name":"widget-10"}}),_vm._v(" "),_c('label',{staticClass:"wah-action-button wahout wah-call-remove-animations is-wah-label",attrs:{"for":"widget-10","data-widgetid":"widget-10","tabindex":"0"}},[_c('span',{staticClass:"wah-module-title",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}},[(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-animation"}):_vm._e(),_vm._v("Remove Animations"),_c('div',{staticClass:"wah-module-desciption"},[_vm._v("Remove animations on this page")])]),_vm._v(" "),_c('span',{staticClass:"wah-animate-checkbox",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"a_module wah_remove_styles",attrs:{"data-module":"widget-11"}},[_c('div',{staticClass:"a_module_exe"},[_c('ol',{staticClass:"switches",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}},[_c('li',{staticClass:"wahout"},[_c('input',{attrs:{"type":"checkbox","tabindex":"-1","id":"widget-11","name":"widget-11"}}),_vm._v(" "),_c('label',{staticClass:"wah-action-button wahout wah-call-remove-styles is-wah-label",attrs:{"for":"widget-11","data-widgetid":"widget-11","tabindex":"0"}},[_c('span',{staticClass:"wah-module-title",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}},[(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-delete"}):_vm._e(),_vm._v("Remove styles"),_c('div',{staticClass:"wah-module-desciption"},[_vm._v("Remove styles on this page")])]),_vm._v(" "),_c('span',{staticClass:"wah-animate-checkbox",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"a_module wah_highlight_titles_setup",attrs:{"data-module":"widget-13"}},[_c('div',{staticClass:"a_module_exe"},[_c('ol',{staticClass:"switches",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}},[_c('li',{staticClass:"wahout"},[_c('input',{attrs:{"type":"checkbox","tabindex":"-1","id":"widget-13","name":"widget-13"}}),_vm._v(" "),_c('label',{staticClass:"wah-action-button wahout wah-highlight-titles wah-call-highlight-titles is-wah-label",attrs:{"for":"widget-13","data-widgetid":"widget-13","tabindex":"0"}},[_c('span',{staticClass:"wah-module-title",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}},[(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-bulb"}):_vm._e(),_vm._v("Highlight titles"),_c('div',{staticClass:"wah-module-desciption"},[_vm._v("Highlight all titles on this page")])]),_vm._v(" "),_c('span',{staticClass:"wah-animate-checkbox",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"a_module wah_image_alt_setup",attrs:{"data-module":"widget-14"}},[_c('div',{staticClass:"a_module_exe"},[_c('ol',{staticClass:"switches",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}},[_c('li',{staticClass:"wahout"},[_c('input',{attrs:{"type":"checkbox","tabindex":"-1","id":"widget-14","name":"widget-14"}}),_vm._v(" "),_c('label',{staticClass:"wah-action-button wahout wah-image-alt wah-call-image-alt is-wah-label",attrs:{"for":"widget-14","data-widgetid":"widget-14","tabindex":"0"}},[_c('span',{staticClass:"wah-module-title",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}},[(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-image"}):_vm._e(),_vm._v("Image description"),_c('div',{staticClass:"wah-module-desciption"},[_vm._v("Display image alt text on mouse over.")])]),_vm._v(" "),_c('span',{staticClass:"wah-animate-checkbox",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"a_module wah_large_cursor",attrs:{"data-module":"widget-16"}},[_c('div',{staticClass:"a_module_exe"},[_c('ol',{staticClass:"switches",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}},[_c('li',{staticClass:"wahout"},[_c('input',{attrs:{"type":"checkbox","tabindex":"-1","id":"widget-16","name":"widget-16"}}),_vm._v(" "),_c('label',{staticClass:"wah-action-button wahout wah_large_cursor wah-call-large_cursor is-wah-label",attrs:{"for":"widget-16","data-widgetid":"widget-16","tabindex":"0"}},[_c('span',{staticClass:"wah-module-title",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}},[(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-arrows"}):_vm._e(),_vm._v("Large cursor"),_c('div',{staticClass:"wah-module-desciption"},[_vm._v("Enable large cursor mode.")])]),_vm._v(" "),_c('span',{staticClass:"wah-animate-checkbox",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"a_module wah_enable_monochrome_mode",attrs:{"data-module":"widget-17"}},[_c('div',{staticClass:"a_module_exe"},[_c('ol',{staticClass:"switches",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}},[_c('li',{staticClass:"wahout"},[_c('input',{attrs:{"type":"checkbox","tabindex":"-1","id":"widget-17","name":"widget-17"}}),_vm._v(" "),_c('label',{staticClass:"wah-action-button wahout wah_enable_monochrome_mode wah-call-monochrome_mode is-wah-label",attrs:{"for":"widget-17","data-widgetid":"widget-17","tabindex":"0"}},[_c('span',{staticClass:"wah-module-title",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}},[(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-black-and-white"}):_vm._e(),_vm._v("Monochrome"),_c('div',{staticClass:"wah-module-desciption"},[_vm._v("Enable monochrome view.")])]),_vm._v(" "),_c('span',{staticClass:"wah-animate-checkbox",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"a_module wah_enable_sepia_mode",attrs:{"data-module":"widget-18"}},[_c('div',{staticClass:"a_module_exe"},[_c('ol',{staticClass:"switches",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}},[_c('li',{staticClass:"wahout"},[_c('input',{attrs:{"type":"checkbox","tabindex":"-1","id":"widget-18","name":"widget-18"}}),_vm._v(" "),_c('label',{staticClass:"wah-action-button wahout wah_enable_sepia_mode wah-call-sepia_mode is-wah-label",attrs:{"for":"widget-18","data-widgetid":"widget-18","id":"wah_enable_sepia_mode","tabindex":"0"}},[_c('span',{staticClass:"wah-module-title",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}},[(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-b-w-drop"}):_vm._e(),_vm._v("Sepia"),_c('div',{staticClass:"wah-module-desciption"},[_vm._v("Enable sepia view.")])]),_vm._v(" "),_c('span',{staticClass:"wah-animate-checkbox",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"a_module wah_enable_inspector_mode",attrs:{"data-module":"widget-19"}},[_c('div',{staticClass:"a_module_exe"},[_c('ol',{staticClass:"switches",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}},[_c('li',{staticClass:"wahout"},[_c('input',{attrs:{"type":"checkbox","tabindex":"-1","id":"widget-19","name":"widget-19"}}),_vm._v(" "),_c('label',{staticClass:"wah-action-button wahout wah_enable_inspector_mode wah-call-inspector_mode is-wah-label",attrs:{"for":"widget-19","data-widgetid":"widget-19","id":"wah_enable_inspector_mode","tabindex":"0"}},[_c('span',{staticClass:"wah-module-title",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}},[(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-corners-screen"}):_vm._e(),_vm._v("Inspector"),_c('div',{staticClass:"wah-module-desciption"},[_vm._v("Enable inspector mode.")])]),_vm._v(" "),_c('span',{staticClass:"wah-animate-checkbox",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"a_module wah_enable_letter_spacing_mode",attrs:{"data-module":"widget-12"}},[_c('div',{staticClass:"a_module_exe"},[_c('ol',{staticClass:"switches",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}},[_c('li',{staticClass:"wahout"},[_c('input',{attrs:{"type":"checkbox","tabindex":"-1","id":"widget-21","name":"widget-21"}}),_vm._v(" "),_c('label',{staticClass:"wah-action-button wahout set-wah-letter_spacing is-wah-label",attrs:{"for":"widget-21","data-widgetid":"widget-21","id":"wah_letter_spacing","tabindex":"0"}},[_c('span',{staticClass:"wah-module-title",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}},[(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-columns"}):_vm._e(),_vm._v("Letter spacing"),_c('div',{staticClass:"wah-module-desciption"},[_vm._v("Enable letter spacing mode.")])]),_vm._v(" "),_c('span',{staticClass:"wah-animate-checkbox",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"a_module wah_enable_adhd_profile",attrs:{"data-module":"widget-22"}},[_c('div',{staticClass:"a_module_exe"},[_c('ol',{staticClass:"switches",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}},[_c('li',{staticClass:"wahout"},[_c('input',{attrs:{"type":"checkbox","tabindex":"-1","id":"widget-22","name":"widget-22"}}),_vm._v(" "),_c('label',{staticClass:"wah-action-button wahout set-wah-adhd_profile is-wah-label",attrs:{"for":"widget-22","data-widgetid":"widget-22","id":"wah_adhd_profile","tabindex":"0"}},[_c('span',{staticClass:"wah-module-title",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}},[(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-view-eye"}):_vm._e(),_vm._v("ADHD Profile"),_c('div',{staticClass:"wah-module-desciption"},[_vm._v("Set more focus on the content.")])]),_vm._v(" "),_c('span',{staticClass:"wah-animate-checkbox",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"a_module wah_enable_mute",attrs:{"data-module":"widget-24"}},[_c('div',{staticClass:"a_module_exe"},[_c('ol',{staticClass:"switches",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}},[_c('li',{staticClass:"wahout"},[_c('input',{attrs:{"type":"checkbox","tabindex":"-1","id":"widget-24","name":"widget-24"}}),_vm._v(" "),_c('label',{staticClass:"wah-action-button wahout set-wah-mute is-wah-label",attrs:{"for":"widget-24","data-widgetid":"widget-24","id":"wah_enable_mute","tabindex":"0"}},[_c('span',{staticClass:"wah-module-title",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}},[(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-sound-icon goi-sound-full"}):_vm._e(),_vm._v("Mute volume"),_c('div',{staticClass:"wah-module-desciption"},[_vm._v("Mute all sounds.")])]),_vm._v(" "),_c('span',{staticClass:"wah-animate-checkbox",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"a_module wah_enable_hide_images",attrs:{"data-module":"widget-25"}},[_c('div',{staticClass:"a_module_exe"},[_c('ol',{staticClass:"switches",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}},[_c('li',{staticClass:"wahout"},[_c('input',{attrs:{"type":"checkbox","tabindex":"-1","id":"widget-25","name":"widget-25"}}),_vm._v(" "),_c('label',{staticClass:"wah-action-button wahout set-wah-hide-images is-wah-label",attrs:{"for":"widget-25","data-widgetid":"widget-25","id":"wah_enable_mute","tabindex":"0"}},[_c('span',{staticClass:"wah-module-title",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}},[(_vm.json.setup.show_icons==true)?_c('span',{staticClass:"goi-image"}):_vm._e(),_vm._v("Hide images"),_c('div',{staticClass:"wah-module-desciption"},[_vm._v("Hide all images.")])]),_vm._v(" "),_c('span',{staticClass:"wah-animate-checkbox",staticStyle:{"font-size":"18px"},attrs:{"data-wahfont":"18"}})])])])])])])])])]):_vm._e()])]):_vm._e()]),_vm._v(" "),(this.free_mode == false)?_c('div',{staticClass:"advanced-settings-container"},[_c('div',{staticClass:"form-row"},[_c('h3',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].advanced_translation_settings)+":\n                        "),_c('i',{class:{ 'on' : _vm.advancedStatus, 'off' : ! _vm.advancedStatus }})])]),_vm._v(" "),_c('label',{staticClass:"inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.advancedSettings),expression:"advancedSettings"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.advancedSettings)?_vm._i(_vm.advancedSettings,null)>-1:(_vm.advancedSettings)},on:{"change":[function($event){var $$a=_vm.advancedSettings,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.advancedSettings=$$a.concat([$$v]))}else{$$i>-1&&(_vm.advancedSettings=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.advancedSettings=$$c}},function($event){return _vm.updateAdvancedSettings()}]}}),_vm._v(" "),_c('span',{staticClass:"span-title"},[_vm._v(_vm._s(_vm.locale[_vm.current_lang].enable_label))])]),_vm._v(" "),_c('transition',{attrs:{"name":"slide"}},[(_vm.advancedSettings)?_c('div',{staticClass:"toggle-advanced-wrapper"},[_c('div',{staticClass:"adv-row"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].advanced_labels.close_button)+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.advanced.close),expression:"advanced.close"}],attrs:{"type":"text"},domProps:{"value":(_vm.advanced.close)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.advanced, "close", $event.target.value)}}})]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].advanced_labels.font_resize)+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.advanced.font_resize),expression:"advanced.font_resize"}],attrs:{"type":"text"},domProps:{"value":(_vm.advanced.font_resize)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.advanced, "font_resize", $event.target.value)}}})]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].advanced_labels.font_size)+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.advanced.font_resize_sign),expression:"advanced.font_resize_sign"}],attrs:{"type":"text"},domProps:{"value":(_vm.advanced.font_resize_sign)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.advanced, "font_resize_sign", $event.target.value)}}})]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].advanced_labels.reset_font_size)+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.advanced.reset_font_size),expression:"advanced.reset_font_size"}],attrs:{"type":"text"},domProps:{"value":(_vm.advanced.reset_font_size)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.advanced, "reset_font_size", $event.target.value)}}})]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].advanced_labels.keyboard_navigation)+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.advanced.keyboard_navigation),expression:"advanced.keyboard_navigation"}],attrs:{"type":"text"},domProps:{"value":(_vm.advanced.keyboard_navigation)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.advanced, "keyboard_navigation", $event.target.value)}}})]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].advanced_labels.readable_font)+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.advanced.readable_font),expression:"advanced.readable_font"}],attrs:{"type":"text"},domProps:{"value":(_vm.advanced.readable_font)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.advanced, "readable_font", $event.target.value)}}})]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].advanced_labels.contrast)+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.advanced.contrast),expression:"advanced.contrast"}],attrs:{"type":"text"},domProps:{"value":(_vm.advanced.contrast)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.advanced, "contrast", $event.target.value)}}})]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].advanced_labels.choose_color)+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.advanced.choose_color),expression:"advanced.choose_color"}],attrs:{"type":"text"},domProps:{"value":(_vm.advanced.choose_color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.advanced, "choose_color", $event.target.value)}}})]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].advanced_labels.highlight_links)+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.advanced.highlight_links),expression:"advanced.highlight_links"}],attrs:{"type":"text"},domProps:{"value":(_vm.advanced.highlight_links)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.advanced, "highlight_links", $event.target.value)}}})]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].advanced_labels.highlight_titles)+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.advanced.highlight_titles),expression:"advanced.highlight_titles"}],attrs:{"type":"text"},domProps:{"value":(_vm.advanced.highlight_titles)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.advanced, "highlight_titles", $event.target.value)}}})]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].advanced_labels.clear_cookies)+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.advanced.clear_cookies),expression:"advanced.clear_cookies"}],attrs:{"type":"text"},domProps:{"value":(_vm.advanced.clear_cookies)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.advanced, "clear_cookies", $event.target.value)}}})]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].advanced_labels.images_greyscale)+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.advanced.images_greyscale),expression:"advanced.images_greyscale"}],attrs:{"type":"text"},domProps:{"value":(_vm.advanced.images_greyscale)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.advanced, "images_greyscale", $event.target.value)}}})]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].advanced_labels.invert_colors)+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.advanced.invert_colors),expression:"advanced.invert_colors"}],attrs:{"type":"text"},domProps:{"value":(_vm.advanced.invert_colors)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.advanced, "invert_colors", $event.target.value)}}})]),_vm._v(" "),_c('label',[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].advanced_labels.remove_animations)+":")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.advanced.remove_animations),expression:"advanced.remove_animations"}],attrs:{"type":"text"},domProps:{"value":(_vm.advanced.remove_animations)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.advanced, "remove_animations", $event.target.value)}}})])])]):_vm._e()])],1)]):_vm._e(),_vm._v(" "),(_vm.code)?_c('div',{staticClass:"buider-preview builder-code"},[_c('div',{staticClass:"builder-step-2"},[_c('div',{staticClass:"step-header"},[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].step2_title))])]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.code),expression:"code"}],ref:"codeEditor",domProps:{"value":(_vm.code)},on:{"click":function($event){return _vm.selectCode()},"input":function($event){if($event.target.composing){ return; }_vm.code=$event.target.value}}}),_vm._v(" "),(_vm.code)?_c('div',{staticClass:"notice-wrapper"},[(_vm.copied)?_c('div',{staticClass:"copied"},[_vm._v("\n                        "+_vm._s(_vm.locale[_vm.current_lang].notice_copied)+"\n                    ")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"builder-step-3"},[_c('div',{staticClass:"step-header"},[_c('span',[_vm._v(_vm._s(_vm.locale[_vm.current_lang].step3_title))])]),_vm._v(" "),_c('div',{staticClass:"step-description step3-description"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.locale[_vm.current_lang].step3_description)}}),_vm._v(" "),_c('div',{staticClass:"code-editor",attrs:{"contenteditable":"true"}},[(!_vm.json.setup.jquery)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.step3_scripts_jquery)}}):_vm._e(),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.locale[_vm.current_lang].step3_script_config)}}),_vm._v(" "),_c('p',[_vm._v("<script src=\"https://accessibility-helper.co.il/remote/wahpro?uid="+_vm._s(_vm.uid)+"\" charset=\"utf-8\"></script>")])]),_vm._v(" "),(!_vm.uid)?_c('div',{staticClass:"notice"},[_vm._v("\n                        "+_vm._s(_vm.locale[_vm.current_lang].error_id_label)+"\n                    ")]):_vm._e()])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"wahout aicon_link layout-wah-modern wah-is-active",staticStyle:{"font-size":"30px","border":"0px","padding":"0px","width":"50px","height":"50px","background-color":"rgb(203, 35, 109) !important","display":"inline-block","left":"-49px","position":"absolute"},attrs:{"type":"button","accesskey":"z","aria-label":"Accessibility Helper sidebar","title":"Accessibility Helper sidebar"}},[_c('span',{staticClass:"goi-wah-icon wah-font-icon",staticStyle:{"font-size":"30px","color":"#ffffff !important"},attrs:{"data-wahfont":"30"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color_selector",attrs:{"aria-hidden":"true"}},[_c('button',{staticClass:"convar black wahout",attrs:{"type":"button","data-bgcolor":"#000","data-color":"#FFF","title":"black background color","aria-label":"black background color","tabindex":"0"}},[_c('span',{staticClass:"wahpro-active-contrast-property",staticStyle:{"background-color":"rgb(0, 0, 0) !important","font-size":"14px"},attrs:{"data-wahfont":"14"}})]),_vm._v(" "),_c('button',{staticClass:"convar white wahout",attrs:{"type":"button","data-bgcolor":"#FFF","data-color":"#000","title":"white background color","aria-label":"white background color","tabindex":"0"}},[_c('span',{staticClass:"wahpro-active-contrast-property",staticStyle:{"background-color":"rgb(255, 255, 255) !important","font-size":"14px"},attrs:{"data-wahfont":"14"}})]),_vm._v(" "),_c('button',{staticClass:"convar green wahout",attrs:{"type":"button","data-bgcolor":"#00FF21","data-color":"#000","title":"green background color","aria-label":"green background color","tabindex":"0"}},[_c('span',{staticClass:"wahpro-active-contrast-property",staticStyle:{"background-color":"rgb(0, 128, 0) !important","font-size":"14px"},attrs:{"data-wahfont":"14"}})]),_vm._v(" "),_c('button',{staticClass:"convar blue wahout",attrs:{"type":"button","data-bgcolor":"#00f","data-color":"#FFD800","title":"blue background color","aria-label":"blue background color","tabindex":"0"}},[_c('span',{staticClass:"wahpro-active-contrast-property",staticStyle:{"background-color":"rgb(0, 0, 255) !important","font-size":"14px"},attrs:{"data-wahfont":"14"}})]),_vm._v(" "),_c('button',{staticClass:"convar red wahout",attrs:{"type":"button","data-bgcolor":"#F00","data-color":"#000","title":"red background color","aria-label":"red background color","tabindex":"0"}},[_c('span',{staticClass:"wahpro-active-contrast-property",staticStyle:{"background-color":"rgb(255, 0, 0) !important","font-size":"14px"},attrs:{"data-wahfont":"14"}})]),_vm._v(" "),_c('button',{staticClass:"convar orange wahout",attrs:{"type":"button","data-bgcolor":"#FF6A00","data-color":"#000","title":"orange background color","aria-label":"orange background color","tabindex":"0"}},[_c('span',{staticClass:"wahpro-active-contrast-property",staticStyle:{"background-color":"rgb(255, 106, 0) !important","font-size":"14px"},attrs:{"data-wahfont":"14"}})]),_vm._v(" "),_c('button',{staticClass:"convar yellow wahout",attrs:{"type":"button","data-bgcolor":"#FFD800","data-color":"#000","title":"yellow background color","aria-label":"yellow background color","tabindex":"0"}},[_c('span',{staticClass:"wahpro-active-contrast-property",staticStyle:{"background-color":"rgb(255, 216, 0) !important","font-size":"14px"},attrs:{"data-wahfont":"14"}})]),_vm._v(" "),_c('button',{staticClass:"convar navi wahout",attrs:{"type":"button","data-bgcolor":"#B200FF","data-color":"#000","title":"navi background color","aria-label":"navi background color","tabindex":"0"}},[_c('span',{staticClass:"wahpro-active-contrast-property",staticStyle:{"background-color":"rgb(178, 0, 255) !important","font-size":"14px"},attrs:{"data-wahfont":"14"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"titles_color_selector",attrs:{"aria-hidden":"true"}},[_c('button',{staticClass:"title-color-trigger white wahout",attrs:{"type":"button","id":"tci-1","data-color":"#FFFFFF","title":"Change color to white","aria-label":"Change color to white","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(255, 255, 255) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"title-color-trigger black wahout",attrs:{"type":"button","id":"tci-2","data-color":"#000000","title":"Change color to black","aria-label":"Change color to black","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(0, 0, 0) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"title-color-trigger green wahout",attrs:{"type":"button","id":"tci-3","data-color":"#008000","title":"Change color to green","aria-label":"Change color to green","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(0, 128, 0) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"title-color-trigger blue wahout",attrs:{"type":"button","id":"tci-4","data-color":"#0000FF","title":"Change color to blue","aria-label":"Change color to blue","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(0, 0, 255) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"title-color-trigger red wahout",attrs:{"type":"button","id":"tci-5","data-color":"#FF0000","title":"Change color to red","aria-label":"Change color to red","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(255, 0, 0) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"title-color-trigger orange wahout",attrs:{"type":"button","id":"tci-6","data-color":"#FFA500","title":"Change color to orange","aria-label":"Change color to orange","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(255, 165, 0) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"title-color-trigger teal wahout",attrs:{"type":"button","id":"tci-7","data-color":"#008080","title":"Change color to teal","aria-label":"Change color to teal","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(0, 128, 128) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"title-color-trigger Yellow wahout",attrs:{"type":"button","id":"tci-8","data-color":"#FFFF00","title":"Change color to Yellow","aria-label":"Change color to Yellow","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(255, 255, 0) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"title-color-trigger Aquamarine wahout",attrs:{"type":"button","id":"tci-9","data-color":"#7FFFD4","title":"Change color to Aquamarine","aria-label":"Change color to Aquamarine","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(127, 255, 212) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"title-color-trigger Lime wahout",attrs:{"type":"button","id":"tci-10","data-color":"#00FF00","title":"Change color to Lime","aria-label":"Change color to Lime","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(0, 255, 0) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text_color_selector",attrs:{"aria-hidden":"true"}},[_c('button',{staticClass:"title-color-trigger white wahout",attrs:{"type":"button","id":"txtci-1","data-color":"#FFFFFF","title":"Change text color to white","aria-label":"Change text color to white","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(255, 255, 255) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"title-color-trigger black wahout",attrs:{"type":"button","id":"txtci-2","data-color":"#000000","title":"Change text color to black","aria-label":"Change text color to black","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(0, 0, 0) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"title-color-trigger green wahout",attrs:{"type":"button","id":"txtci-3","data-color":"#008000","title":"Change text color to green","aria-label":"Change text color to green","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(0, 128, 0) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"title-color-trigger blue wahout",attrs:{"type":"button","id":"txtci-4","data-color":"#0000FF","title":"Change text color to blue","aria-label":"Change text color to blue","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(0, 0, 255) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"title-color-trigger red wahout",attrs:{"type":"button","id":"txtci-5","data-color":"#FF0000","title":"Change text color to red","aria-label":"Change text color to red","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(255, 0, 0) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"title-color-trigger orange wahout",attrs:{"type":"button","id":"txtci-6","data-color":"#FFA500","title":"Change text color to orange","aria-label":"Change text color to orange","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(255, 165, 0) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"title-color-trigger teal wahout",attrs:{"type":"button","id":"txtci-7","data-color":"#008080","title":"Change text color to teal","aria-label":"Change text color to teal","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(0, 128, 128) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"title-color-trigger Yellow wahout",attrs:{"type":"button","id":"txtci-8","data-color":"#FFFF00","title":"Change text color to yellow","aria-label":"Change text color to yellow","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(255, 255, 0) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"title-color-trigger Aquamarine wahout",attrs:{"type":"button","id":"txtci-9","data-color":"#7FFFD4","title":"Change text color to aquamarine","aria-label":"Change text color to aquamarine","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(127, 255, 212) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"title-color-trigger Lime wahout",attrs:{"type":"button","id":"txtci-10","data-color":"#00FF00","title":"Change text color to lime","aria-label":"Change text color to lime","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(0, 255, 0) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link_color_selector",attrs:{"aria-hidden":"true"}},[_c('button',{staticClass:"link-color-trigger white wahout",attrs:{"type":"button","id":"linkci-1","data-color":"#FFFFFF","title":"Change link color to white","aria-label":"Change link color to white","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(255, 255, 255) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"link-color-trigger black wahout",attrs:{"type":"button","id":"linkci-2","data-color":"#000000","title":"Change link color to black","aria-label":"Change link color to black","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(0, 0, 0) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"link-color-trigger green wahout",attrs:{"type":"button","id":"linkci-3","data-color":"#008000","title":"Change link color to green","aria-label":"Change link color to green","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(0, 128, 0) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"link-color-trigger blue wahout",attrs:{"type":"button","id":"linkci-4","data-color":"#0000FF","title":"Change link color to blue","aria-label":"Change link color to blue","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(0, 0, 255) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"link-color-trigger red wahout",attrs:{"type":"button","id":"linkci-5","data-color":"#FF0000","title":"Change link color to red","aria-label":"Change link color to red","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(255, 0, 0) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"link-color-trigger orange wahout",attrs:{"type":"button","id":"linkci-6","data-color":"#FFA500","title":"Change link color to orange","aria-label":"Change link color to orange","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(255, 165, 0) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"link-color-trigger teal wahout",attrs:{"type":"button","id":"linkci-7","data-color":"#008080","title":"Change link color to teal","aria-label":"Change link color to teal","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(0, 128, 128) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"link-color-trigger Yellow wahout",attrs:{"type":"button","id":"linkci-8","data-color":"#FFFF00","title":"Change link color to yellow","aria-label":"Change link color to yellow","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(255, 255, 0) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"link-color-trigger Aquamarine wahout",attrs:{"type":"button","id":"linkci-9","data-color":"#7FFFD4","title":"Change link color to aquamarine","aria-label":"Change link color to aquamarine","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(127, 255, 212) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})]),_vm._v(" "),_c('button',{staticClass:"link-color-trigger Lime wahout",attrs:{"type":"button","id":"linkci-10","data-color":"#00FF00","title":"Change link color to lime","aria-label":"Change link color to lime","tabindex":"0"}},[_c('span',{staticStyle:{"background-color":"rgb(0, 255, 0) !important","font-size":"21px"},attrs:{"data-wahfont":"21"}}),_c('span',{staticClass:"indicator",staticStyle:{"font-size":"21px"},attrs:{"data-wahfont":"21"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "teIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_625f2311_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("OMfZ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_625f2311_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Builder__ = __webpack_require__("YrQk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Header__ = __webpack_require__("teIl");
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    components: {
        Builder: __WEBPACK_IMPORTED_MODULE_0__components_Builder__["a" /* default */],
        appHeader: __WEBPACK_IMPORTED_MODULE_1__components_Header__["a" /* default */]
    }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.bf2522dec2147176b591.js